import { render, staticRenderFns } from "./PositionAreaInput.vue?vue&type=template&id=fa9cf27c"
import script from "./PositionAreaInput.vue?vue&type=script&lang=js"
export * from "./PositionAreaInput.vue?vue&type=script&lang=js"
import style0 from "./PositionAreaInput.vue?vue&type=style&index=0&id=fa9cf27c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports